module.exports = __webpack_public_path__ + "img/logo.1a1ef3f0.png";